/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const LockedPadlockIconOutline = createIcon({
  displayName: 'LockedPadlockIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M17,21h-10c-1.105,0 -2,-0.895 -2,-2v-8c0,-1.105 0.895,-2 2,-2h10c1.105,0 2,0.895 2,2v8c0,1.105 -0.895,2 -2,2Z"></path>
        <path d="M12,17.09v-2.59"></path>
        <path d="M12.5303,13.2197c0.292893,0.292893 0.292893,0.767767 0,1.06066c-0.292893,0.292893 -0.767767,0.292893 -1.06066,0c-0.292893,-0.292893 -0.292893,-0.767767 0,-1.06066c0.292893,-0.292893 0.767767,-0.292893 1.06066,0"></path>
        <path d="M8,9v-2v0c0,-2.209 1.791,-4 4,-4v0c2.209,0 4,1.791 4,4v0v2"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const LockedPadlock: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    default:
      return <CustomIcon as={LockedPadlockIconOutline} {...props} />
  }
}

export default memo(LockedPadlock)
